import React, { ReactElement } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import ValidationPage from './containers/Body/ValidationPage';
import { Footer } from './containers/Footer';
import { LoadingModal } from './components/modals/LoadingModal';
import AssetSelectionPage from './containers/Body/AssetSelectionPage';
import Header from './containers/Header';
import { Layout, Masthead } from 'mesh-component-library';

// oh u fancy huh
const App = (): ReactElement => {
    return (
        <Layout
            isFullWidth={false}
            variant="blue-beacon"
            header={
                <Layout.Header>
                    <Masthead logoAlt="Allstate Insurance" logoType="brand-only" />
                </Layout.Header>
            }
            jumbotron={
                <Layout.Jumbotron className="jumbotron">
                    <div className="jumbotron-title">
                        Claims | <span style={{ color: '#45bce5' }}>photos</span>
                    </div>
                </Layout.Jumbotron>
            }
            footer={<Layout.Footer>{<Footer />}</Layout.Footer>}
        >
            <Layout.Main>
                <Header />
                <LoadingModal />
                <Switch>
                    <Route exact component={ValidationPage} path="/" />
                    <Route exact component={AssetSelectionPage} path="/asset" />
                    <Redirect to="/" />
                </Switch>
            </Layout.Main>
        </Layout>
    );
};

export default App;
